import _find from 'lodash.find'
import _reverse from 'lodash.reverse'
import _sortBy from 'lodash.sortby'
import gridColumns from '../gridColumns'
import i18n from '@/i18n'

import type { GetterTree } from 'vuex'
import type { GridColumn } from '@/@types'
import type { ScriptsState } from './state'
import type { RootState } from '@/store/state'
import type { ScriptsSortingState, ScriptUnit, ScriptInstance, SchemeCardInfo } from '@/models/scripts'

const clearInstance: ScriptInstance = {
  id: '',
  ver: 0,
  date: 0,
  steps: 0,
  pass: 0,
  target: 0,
  conversion: 0,
  duration: 0,
}

export const getters: GetterTree<ScriptsState, RootState> = {
  getScriptScheme: (state: ScriptsState) => state.scheme,

  getSchemeUpdate: (state: ScriptsState) => state.scheme.update,

  getSchemeRoot: (state: ScriptsState): SchemeCardInfo | undefined => {
    if (state.scheme.root !== null) {
      return state.scheme.map[state.scheme.root]
    }
    return undefined
  },

  getScriptsList: (state): ScriptUnit[] => {
    const instanceKeys = Object.keys(clearInstance).filter(
      (key: string) => key !== 'id',
    )
    let iteratee
    if (instanceKeys.includes(state.sortColumn)) {
      iteratee = (one: ScriptUnit) => {
        const instance = one.instance as ScriptInstance
        if (instance[state.sortColumn as keyof ScriptInstance] !== undefined) {
          return instance[state.sortColumn as keyof ScriptInstance]
        }
        return 0
      }
    } else {
      iteratee = (one: ScriptUnit) => one[state.sortColumn as 'id' | 'title']
    }
    let list = _sortBy(state.list, iteratee)
    if (state.sortAsc !== true) {
      list = _reverse(list)
    }
    return list
  },

  getScriptColumns: (state, rootGetters): GridColumn[] => {
    return gridColumns
      .map(c => ({
        ...c,
        title: c.title ? i18n.tc(c.title) : c.title,
        label: c.label ? i18n.tc(c.label) : c.label,
      }))
      .filter((column: GridColumn) => rootGetters.canDoScope(column.scope))
  },

  getScriptsSorting: (state: ScriptsState): ScriptsSortingState => ({
    asc: state.sortAsc,
    column: state.sortColumn,
  }),

  getScriptById: (state: ScriptsState) => (
    id: string,
  ): ScriptUnit | undefined => {
    return _find(state.list, script => script.id === id)
  },
}
